import { styled, Button } from '@clickcease/cc-client-components-lib'

export const PlanBoxFeatureRowText = styled('div', {
  display: 'flex',
  width: '250px',
  marginLeft: '$4',
  fontSize: '$lg',
  fontWeight: '$r',
  textAlign: 'left',

  variants: {
    crossSell: {
      true: {
        '@laptop': {
          fontSize: '$sm',
          width: '200px',
        },
      },
    },
  },
})

export const BundlePlanBoxPriceRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
})

export const BundlePlanBoxButtonAndPrice = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '@bp1': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '$8',
  },
})

export const BundlePlanBoxPrice = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const StartFreeTrialButton = styled(Button, {
  width: 'auto',
  height: '30px',
  maxHeight: '42px',
  maxWidth: 'unset',
  marginTop: '16px',
})

export const PlanBoxLetsTalk = styled('div', {
  fontWeight: '$sb',
  fontSize: '$h1',
})

export const PlanBoxCurrency = styled('div', {
  fontSize: '$h3',
  fontWeight: '$sb',

  '@bp1': {
    fontSize: '$lg',
    height: 'fit-content',
  },
})

export const PlanBoxAmount = styled('div', {
  fontSize: '36px',
  fontWeight: '800',

  '@bp1': {
    fontSize: '$h4',
  },
})

export const PlanBoxPeriod = styled('div', {
  fontSize: '$lg',
  fontWeight: '$r',

  '@bp1': {
    lineHeight: 'normal',
  },
})

export const PlanBoxOriginalPrice = styled('div', {
  fontSize: '$lg',
  fontWeight: '$r',
  margin: '0px 0px 0px $6',
  position: 'relative',

  '&:before': {
    position: 'absolute',
    content: '',
    left: '-5px',
    top: '50%',
    width: '45px',
    right: '0',
    borderTop: '$black 1px solid',

    '-webkit-transform': 'rotate(342deg)',
    '-moz-transform': 'rotate(342deg)',

    '-ms-transform': 'rotate(342deg)',
    '-o-transform': 'rotate(342deg)',
    transform: 'rotate(342deg)',
  },
})

export const PlanBoxBilledAnnually = styled('div', {
  fontSize: '$sm',
  fontWeight: '$r',
  display: 'flex',
})

export const BundlePlanBoxBilledAnnually = styled('div', {
  fontWeight: '$r',
  fontSize: '$sm',
  width: '100px',
})
